import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import isAccessTokenValid from '@app/helpers/isAccessTokenValid'
import { withStyles } from '@app/components/styles'
import {
  saveConditionRoomState,
  saveConditionStateDescription,
  saveConditionType,
} from '@app/actions/scenes/currentSceneCreating'
import * as syncNotifications from '@app/actions/notifications/notificationsChannel'
import { isIOS } from 'react-device-detect'
import SelectRoomConditionState
  from '@app/components/MyAutomation/Tabs/ScenesScreens/CreateCondition/RoomCondition/SelectRoomConditionState'
import SelectRoomConditionStateIOS
  from '@app/components/MyAutomation/Tabs/iOS/CreateCondition/RoomCondition/SelectRoomConditionState'
import { withAccessDenied, withNotifications, withRouter } from '@app/hocs'

const isWebView = navigator.userAgent.includes('WebView') || navigator.userAgent.includes('wv')
let enhance = isIOS && isWebView ? withStyles(SelectRoomConditionStateIOS) : withStyles(SelectRoomConditionState)

const mapStateToProps = (state) => {
  const { isMobile } = state.mobileDetector
  const { isEditConditionMode, isChangeConditionStateMode } = state.scenes.currentSceneCreating
  return {
    isMobile,
    isEditConditionMode,
    isChangeConditionStateMode,
    inProgress: state.apiRequest.inProgress,
    errorMessage: state.apiRequest.errorMessage,
    accessDenied: !isAccessTokenValid(state.secrets.accessToken),
  }
}

const mapDispatchToProps = (dispatch) => bindActionCreators({
  notifications: syncNotifications.sync,
  saveConditionType,
  saveConditionStateDescription,
  saveConditionRoomState,
}, dispatch)

enhance = withAccessDenied(enhance)
enhance = withNotifications(enhance)
enhance = connect(mapStateToProps, mapDispatchToProps)(enhance)

const SelectRoomConditionStateEnhanced = enhance

export default withRouter(SelectRoomConditionStateEnhanced)
